import { render, staticRenderFns } from "./PortfolioStats.vue?vue&type=template&id=a84c0690&scoped=true"
import script from "./PortfolioStats.vue?vue&type=script&lang=js"
export * from "./PortfolioStats.vue?vue&type=script&lang=js"
import style0 from "./PortfolioStats.vue?vue&type=style&index=0&id=a84c0690&prod&lang=scss&scoped=true"
import style1 from "./PortfolioStats.vue?vue&type=style&index=1&id=a84c0690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84c0690",
  null
  
)

export default component.exports